export enum VehicleBodyTypes {
  SEDAN = 'Sedan',
  COUPE = 'Coupe',
  SUV = 'SUV',
  CONVERTIBLE = 'Convertible',
  HATCHBACK = 'Hatchback',
  WAGON = 'Wagon',
  PICKUP = 'Pickup',
  MINIVAN = 'Minivan',
  WORK_VAN = 'Work_Van',
  SEMI_TRUCK = 'Semi_Truck',
  MOTORCYCLE = 'Motorcycle',
  GOLF_CART = 'Golf_Cart',
  TRAILER = 'Trailer',
  BICYCLE = 'Bicycle',
  BOX_TRUCK = 'Box_Truck',
  BUS = 'Bus',
}

export enum VehicleColorTypes {
  WHITE = 'white',
  SILVER_GREY = 'silver_grey',
  BLACK = 'black',
  BLUE = 'blue',
  RED = 'red',
  BROWN = 'brown',
  YELLOW = 'yellow',
  GREEN = 'green',
}

export enum VehicleMakeTypes {
  ACURA = 'Acura',
  AUDI = 'Audi',
  BENTLEY = 'Bentley',
  BMW = 'BMW',
  BUICK = 'Buick',
  CADILLAC = 'Cadillac',
  CHEVROLET = 'Chevrolet',
  CHRYSLER = 'Chrysler',
  DODGE = 'Dodge',
  FERRARI = 'Ferrari',
  FIAT = 'Fiat',
  FORD = 'Ford',
  GMC = 'GMC',
  HONDA = 'Honda',
  HUMMER = 'Hummer',
  HYUNDAI = 'Hyundai',
  INFINITI = 'Infiniti',
  JAGUAR = 'Jaguar',
  JEEP = 'Jeep',
  KIA = 'Kia',
  LAND_ROVER = 'Land_Rover',
  LEXUS = 'Lexus',
  LINCOLN = 'Lincoln',
  MASERATI = 'Maserati',
  MAZDA = 'Mazda',
  MERCEDES = 'Mercedes',
  MERCURY = 'Mercury',
  MINI = 'Mini',
  MITSUBISHI = 'Mitsubishi',
  NISSAN = 'Nissan',
  OLDSMOBILE = 'Oldsmobile',
  OTHER = 'Other',
  PONTIAC = 'Pontiac',
  PORSCHE = 'Porsche',
  RAM = 'Ram',
  SAAB = 'Saab',
  SATURN = 'Saturn',
  SCION = 'Scion',
  SMART = 'Smart',
  SUBARU = 'Subaru',
  SUZUKI = 'Suzuki',
  TESLA = 'Tesla',
  TOYOTA = 'Toyota',
  VOLKSWAGEN = 'Volkswagen',
  VOLVO = 'Volvo',
}

export enum PlateResultSort {
  ASC = 'asc',
  DESC = 'desc',
}

export enum RecordType {
  ALL = 'all',
  HIT = 'hit',
}

export const US_STATES_VALUES_TO_CODES = [
  { code: 'AL', value: 'alabama' },
  { code: 'AK', value: 'alaska' },
  { code: 'AS', value: 'american_samoa' },
  { code: 'AZ', value: 'arizona' },
  { code: 'AR', value: 'arkansas' },
  { code: 'CA', value: 'california' },
  { code: 'CO', value: 'colorado' },
  { code: 'CT', value: 'connecticut' },
  { code: 'DE', value: 'delaware' },
  { code: 'DC', value: 'district_of_columbia' },
  { code: 'FM', value: 'federated_states_of_micronesia' },
  { code: 'FL', value: 'florida' },
  { code: 'GA', value: 'georgia' },
  { code: 'GU', value: 'guam' },
  { code: 'HI', value: 'hawaii' },
  { code: 'ID', value: 'idaho' },
  { code: 'IL', value: 'illinois' },
  { code: 'IN', value: 'indiana' },
  { code: 'IA', value: 'iowa' },
  { code: 'KS', value: 'kansas' },
  { code: 'KY', value: 'kentucky' },
  { code: 'LA', value: 'louisiana' },
  { code: 'ME', value: 'maine' },
  { code: 'MH', value: 'marshall_islands' },
  { code: 'MD', value: 'maryland' },
  { code: 'MA', value: 'massachusetts' },
  { code: 'MI', value: 'michigan' },
  { code: 'MN', value: 'minnesota' },
  { code: 'MS', value: 'mississippi' },
  { code: 'MO', value: 'missouri' },
  { code: 'MT', value: 'montana' },
  { code: 'NE', value: 'nebraska' },
  { code: 'NV', value: 'nevada' },
  { code: 'NH', value: 'new_hampshire' },
  { code: 'NJ', value: 'new_jersey' },
  { code: 'NM', value: 'new_mexico' },
  { code: 'NY', value: 'new_york' },
  { code: 'NC', value: 'north_carolina' },
  { code: 'ND', value: 'north_dakota' },
  { code: 'MP', value: 'northern_mariana_islands' },
  { code: 'OH', value: 'ohio' },
  { code: 'OK', value: 'oklahoma' },
  { code: 'OR', value: 'oregon' },
  { code: 'PW', value: 'palau' },
  { code: 'PA', value: 'pennsylvania' },
  { code: 'PR', value: 'puerto_rico' },
  { code: 'RI', value: 'rhode_island' },
  { code: 'SC', value: 'south_carolina' },
  { code: 'SD', value: 'south_dakota' },
  { code: 'TN', value: 'tennessee' },
  { code: 'TX', value: 'texas' },
  { code: 'UT', value: 'utah' },
  { code: 'VT', value: 'vermont' },
  { code: 'VI', value: 'virgin_islands' },
  { code: 'VA', value: 'virginia' },
  { code: 'WA', value: 'washington' },
  { code: 'WV', value: 'west_virginia' },
  { code: 'WI', value: 'wisconsin' },
  { code: 'WY', value: 'wyoming' },
];

// Plate state constants
export const PLATE_STATE_DISTRICT_OF_COLUMBIA = 'district_of_columbia';
export const PLATE_STATE_WASHINGTON_DC = 'washington_dc';
